import React, { useEffect, useState } from "react";
import GameBoard from "../components/newgame/components/GameBoard";
import parse from 'html-react-parser';
import ModalInstruction from "../components/ModalInstruction";
import { getText } from "../utils/languageUtils";

export default function PairMatchGame({ question,
  language,
  }) {

  const [running, setRunning] = useState(false);
  const [level, setLevel] = useState();
  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  
  useEffect(() => {
    setLevel(question?.question_option?.length * 2)
  }, [])


  return (
    <div>
      <div className="justify-content-end d-flex">
        <div onClick={handleShow}>
          <img
            src={require("../assets/images/instructions.png")}
            className="mobielViewIcon"
            alt="instructions"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 mb-4">
          <div className="sectionsBox">
            <p className="mb-0 text-center">{getText(question.title, language)}</p>
          </div>
        </div>
      </div>
      <div className="col-12 ">
        {getText(question.description, language).length > 0 && (
          <div className="contentbox mb-4">
            <div className="content_safty ">
              {parse(getText(question.description, language))}
            </div>
          </div>
        )}
      </div>
      
        <GameBoard level={level} onExitGame={() => setRunning(false)} question={question} language={language} />
   
      <ModalInstruction
        show={show}
        handleClose={handleClose}
        inst={parse(getText(question.instruction, language))}
      />
    </div>
  );
}
